/**
 * 品牌信息 Pinia Store（登录页 / 顶栏共用）
 *
 * 数据来自公开接口 /api/public/landing/branding（管理端"基础设置"的系统名称与 Logo）。
 * 加载失败静默降级：调用方以 `systemName || '智台账'` 回退默认品牌名。
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { publicBrandingHttpService, type PublicBranding } from '@/services/public-branding-http'

export const useBrandingStore = defineStore('branding', () => {
  const systemName = ref('')
  const logo = ref('')
  const loaded = ref(false)

  // 进行中的请求共享，防止登录页/顶栏同时挂载时重复发起
  let pending: Promise<void> | null = null

  async function loadBranding() {
    if (loaded.value) return
    if (pending) return pending
    pending = publicBrandingHttpService.getBranding().then((data: PublicBranding | null) => {
      if (data) {
        systemName.value = data.systemName || ''
        logo.value = data.logo || ''
      }
      loaded.value = true
    }).finally(() => {
      pending = null
    })
    return pending
  }

  return { systemName, logo, loaded, loadBranding }
})
